export enum StatusSolicitacao {
  Pendente = 'PENDENTE',
  Aprovado = 'APROVADO',
  Recusado = 'RECUSADO',
  ComObservacao = 'COM_OBSERVACAO',
  PendenteDeJustificativa = 'PENDENTE_DE_JUSTIFICATIVA',
  VencidaDeJustificativa = 'VENCIDA_DE_JUSTIFICATIVA',
  VencidaDeResposta = 'VENCIDA_DE_RESPOSTA',
  Cancelado = 'CANCELADO'
}

export enum AcoesSobreSolicitacaoEnum {
  Aprovar = 'APROVAR',
  Reprovar = 'REPROVAR'
}

export enum TipoDeSolicitacao {
  CorrecaoDePonto = 'correcao_de_ponto',
  Dispensa = 'dispensa',
  ConversaoDeApontamento = 'conversao_de_apontamento',
  AlteracaoDeEscala = 'alteracao_de_escala',
  Suspensao = 'suspensao',
  Ferias = 'ferias',
  HorasExtras = 'horas_extras',
  Sobreaviso = 'sobreaviso'
}

export enum TipoDeSolicitacaoHE {
  PreAprovada = "PRE_APROVADA",
  SolicitadaComAntecedencia = "SOLICITADA_COM_ANTECEDENCIA",
  JustificadaAposRealizada = "JUSTIFICADA_APOS_REALIZAR"
}

export enum TipoDeUsuario {
  Lider = 'lider',
  Pessoal = 'pessoal'
}

export enum IdsTipoDeSolicitacao {
  Pendente = 'pending',
  Aprovado = 'approved',
  Reprovado = 'reproved',
  Problema = 'problem',
  VencidaDeResposta = 'VENCIDA_DE_RESPOSTA',
  Cancelado = 'CANCELADO',
  PendenteDeJustificativa = 'PENDENTE_DE_JUSTIFICATIVA',
  VencidaDeJustificativa = 'VENCIDA_DE_JUSTIFICATIVA',
}

export enum IdsTipoDeEvento {
  Todos = 'all',
  CorrecaoDePonto = 'fktls',
  Dispensa = 'just',
  Suspensao = 'suspensao',
  ConversaoBH = 'conversaoBH',
  AlteracaoEscala = 'alteracaoEscala',
  Ferias = 'ferias',
  HorasExtra = 'horasExtras',
  Sobreaviso = 'sobreaviso'
}

export enum LegendaDaJornada {
  FERIAS = 'Férias',
  FERIADO = 'Feriado',
  DISPENSA = 'Dispensa',
  AFASTAMENTO = 'Afastamento',
  SEM_JORNADA = 'Sem Jornada',
  FOLGA = 'Folga',
  SUSPENSAO = 'Suspensão'
}